/** URLs externas usadas por el landing v5. Centralizadas para que un cambio
 *  de waitlist (Netlify ↔ Tally ↔ Typeform) sea un único edit. */
export const WAITLIST_URL = 'https://arku-waitlist.netlify.app';
